import { render, staticRenderFns } from "./multi-index.vue?vue&type=template&id=72e52224&scoped=true&"
import script from "./multi-index.vue?vue&type=script&lang=js&"
export * from "./multi-index.vue?vue&type=script&lang=js&"
import style0 from "./multi-index.vue?vue&type=style&index=0&id=72e52224&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e52224",
  null
  
)

export default component.exports